import React, { memo } from 'react'
import { TableContainer } from '@mui/material'

import TableHeaderBody from './TableHeaderBody'

const DataTable = ({ ...restProps }) => {
  return (
    <TableContainer sx={{ maxHeight: 490 }}>
      <TableHeaderBody {...restProps} />
    </TableContainer>
  )
}

export default memo(DataTable)
